// extracted by mini-css-extract-plugin
export default {"activityFormContainer":"CreateActivity_activityFormContainer__Ey94X"};